module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-28.884921f5.jpg";